var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"select"},[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{class:_vm.idxId==index?'active':'',on:{"click":function($event){$event.preventDefault();return _vm.handleClick($event,index,item)}}},[_vm._v(" "+_vm._s(item.name)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }